import request from '../api';

export const startPaymentCheckout = async (paymentId) => {
    const { data } = await request.post('/epayment/checkout', { paymentId });

    if (!data?.checkoutUrl) {
        throw new Error('Missing payment checkout URL');
    }

    window.location.assign(data.checkoutUrl);
};
